import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { AgendaSmallIcon } from '../../../../../../Common/Icons/ActionCenter/Widget/AgendaIcon';
import { ToDoSmallIcon } from '../../../../../../Common/Icons/ActionCenter/Widget/ToDoIcon';
import {ConfirmSmallIcon} from '../../../../../../Common/Icons/ActionCenter/Widget/ConfirmIcon';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createCustomTheme } from '../../../../../../../../utils/theming'

const _styles = theme => ({
    container: {
        marginTop: 8,
        '&:last-child': {
            marginRight: 0
        },
        marginRight: 8,
        borderRadius: 8,
        background: '#fff',
        paddingRight: 8,
        paddingLeft: 8,
        cursor: 'pointer',
        height: 22,
        border: `1px solid ${theme.customColors.primary.main}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    selectedContainer: {
        background: theme.customColors.primary.main,
        border: `1px solid ${theme.customColors.primary.main}`,
    },
    titleText: {
        marginLeft: 4,
        whiteSpace: 'nowrap',
        color: theme.customColors.primary.main,
        letterSpacing: 0.4,
        fontFamily: 'Rubik',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '16px',
    },
    selectedTitleText: {
        color: '#fff',
    },
    row1: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
});

const titles = {
    'agenda': 'Agenda',
    'todo': 'To Do',
    'mustRead': 'To Sign'
}
function __ControlOption(props) {
    const {selected, view, onPressView, count, classes: styles, brandingColor} = props
    const colors = createCustomTheme(brandingColor);

    const [t] = useTranslation("feedWidgets")
    const isSelected = React.useMemo(() => selected === view, [selected, view])

    const onPress = React.useCallback(() => {
        onPressView(view)
    }, [onPressView, view])

    const renderIcon = () => {
        switch (view) {
            case 'agenda':
                return <AgendaSmallIcon color={isSelected ? '#FFF' : colors.primary.main} />
            case 'todo':
                return <ToDoSmallIcon color={isSelected ? '#FFF' : colors.primary.main} />
            case 'mustRead':
                return <ConfirmSmallIcon color={isSelected ? '#FFF' : colors.primary.main} />        
            default:
                return null
        }
    }

    return <div data-intrcm-id="ControlOption_elgd0aaw" onClick={onPress} className={`${styles.container} ${isSelected ? styles.selectedContainer : ''}`}>
        <div data-intrcm-id="ControlOption_mhwol48s" className={styles.row1}>
            {renderIcon()}
            {!isSelected ? null : <div data-intrcm-id="ControlOption_deeqokhg" className={`${styles.titleText} ${isSelected ? styles.selectedTitleText : ''}`} >{!!titles[view] ? t(titles[view]) : t("Untitled")}</div>}
            <div data-intrcm-id="ControlOption_ob49o4t3" style={{marginLeft: 4}} className={`${styles.titleText} ${isSelected ? styles.selectedTitleText : ''}`} >({count})</div>
        </div>
    </div>
}

const mapStateToProps = (state) => {
    return {
        brandingColor: state.userData.profileData.org.brandingColor,
    }  
}

export const ControlOption = compose(
    withStyles(_styles, {withTheme: true}),
    connect(mapStateToProps),
)(__ControlOption)